import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { fetchSoftwareCategories } from '../ungatedContent/ungatedContentThunk';
import { GenericObjectInterface } from '@/src/utilities';
import { fetchWhitepapers } from './gatedContentThunk';
export interface GatedContentState {
  whitepapers: GenericObjectInterface[] | null
  useCases: GenericObjectInterface[] | null
}

const initialState: GatedContentState = {
  whitepapers: null,
  useCases: null
}

export const gatedContentSlice = createSlice({
  name: 'gatedContent',
  initialState,
  reducers: {
    whitepapers: (state, action: PayloadAction<GenericObjectInterface[]>) => {
      state.whitepapers = action.payload
    },
    useCases: (state, action: PayloadAction<GenericObjectInterface[]>) => {
      state.useCases = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchWhitepapers
        .fulfilled,
      (state, action: PayloadAction<GenericObjectInterface>) => {
        const data = action.payload?.data?.data;

        if (data && data?.length > 0) {

          // Filter whitepapers
          const whitepapers = data.filter(
            (item: GenericObjectInterface) => item?.type_id?.name === 'whitepaper'
          );

          // Filter use cases
          const useCases = data.filter(
            (item: GenericObjectInterface) => item?.type_id?.name === 'case_study'
          );

          // Update state with filtered data
          if (whitepapers.length > 0) {
            state.whitepapers = whitepapers;
          }

          if (useCases.length > 0) {
            state.useCases = useCases;
          }
        }
      }
    );

  },
})

// Action creators are generated for each case reducer function
export const { whitepapers, useCases } = gatedContentSlice.actions

export default gatedContentSlice.reducer